import React, { useState, useEffect, ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchInput from './SearchInput';
import OpenFilterButton from './OpenFilterButton';
import FiltersListDropdown from './FiltersListDropdown';
import { filtersManager } from './filtering/filtersManager';
import {ItemsStorageService} from "./filtering/itemsStorageService";

interface SearchItemBlockProps {
    itemsStorageService: ItemsStorageService,
    placeholder: string,
    actions?: ReactNode,
}

const SearchItemBlock = ({ itemsStorageService, placeholder, actions }: SearchItemBlockProps) => {
    const [filtersListIsOpen, setFiltersListIsOpen] = useState(false);
    const [searchParams] = useSearchParams();

    const changeFiltersListState = (value: boolean) => {
        setFiltersListIsOpen(value);
    };

    useEffect(() => {
        filtersManager.registerOpenStateObserver(changeFiltersListState);
        itemsStorageService.setInitialFilters(searchParams, () => filtersManager.notifyFiltersChanged());
        return () => filtersManager.cleanObservers();
    }, []);

    return (
        <>
            <div className="product__toolbar">
                <article className={`product__article product__article-list product__search ${filtersListIsOpen ? 'product__article-list_active' : ''}`}>
                    <SearchInput itemsStorageService={itemsStorageService} placeholder={placeholder}/>
                    <OpenFilterButton itemsStorageService={itemsStorageService} />
                </article>
                {actions ? (
                    <div className="product__toolbar-actions">
                        {actions}
                    </div>
                ) : null}
            </div>
            <FiltersListDropdown itemsStorageService={itemsStorageService} />
        </>
    );
};

export default SearchItemBlock;
